import { Heading } from '@/components/heading';
import { Text } from '@/components/text';
import { UNIT_CO2, UNIT_CO2_KG } from '@/lib/constants';
import { EmissionStats } from '@/types';
import { formatEmissionsNum, formatEmissionsRangeString, formatEmissionsUnit } from '@/utils/format/emissions';
import { tv } from '@/utils/styles';

import { OptionSummaryCard } from '..';

export interface EmissionSummaryCardProps {
  emissions?: EmissionStats;
  secondaryEmissions?: number;
}

const EmissionSummaryCard = ({ emissions, secondaryEmissions }: EmissionSummaryCardProps) => {
  const { cardHeading, cardPreHeading, cardHeadingUnit, cardNote, cardNoteText, cardNoteBadge } = styles();

  return (
    <OptionSummaryCard title="Typical emissions">
      <Text className={cardPreHeading()}>{emissions?.unit === UNIT_CO2_KG ? 'Avg. per 100kg' : 'Avg. per TEU'}</Text>
      {emissions && (
        <Heading as="h4" variant="h3" className={cardHeading()}>
          {formatEmissionsRangeString(emissions, false, false)}
          <small className={cardHeadingUnit()}>
            {formatEmissionsUnit(emissions.average)} {UNIT_CO2}
          </small>
        </Heading>
      )}
      <div className={cardNote()}>
        <div className={cardNoteBadge()}>
          + {formatEmissionsNum(secondaryEmissions || 0)} {UNIT_CO2}
        </div>
        <Text className={cardNoteText()}>road emissions</Text>
      </div>
    </OptionSummaryCard>
  );
};

const styles = tv({
  slots: {
    cardHeading: 'mb-1 font-semibold leading-tight',
    cardPreHeading: 'm-0 text-[10px] font-medium uppercase leading-tight',
    cardHeadingUnit: 'text-sm',
    cardNote: 'mt-3 flex items-center gap-1.5',
    cardNoteBadge: 'm-0 flex items-center gap-1.5 rounded bg-yellow/40 px-1 text-xs font-medium',
    cardNoteText: 'm-0 text-xs italic text-grey-500',
  },
});

export { EmissionSummaryCard };
